/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import {FormattedDate} from 'react-intl';

const LocalDayOfWeekLong = ({ data }) => (
    <FormattedDate
        value={data}
        day='numeric'
        month='long'
        weekday="long"
    />
);

export default LocalDayOfWeekLong;


/** WEBPACK FOOTER **
 ** ./src/components/LocalDayOfWeekLong.jsx
 **/